<template>
  <AppClientSimpleLayout>
    <div class="my-5">
      <h2 class="mb-5 text-xl font-iroha text-center text-CLIENT_PRIMARY_PINK leading-tight">
        お知らせ一覧
      </h2>
      <div
        v-if="!informationList.length">
        <p>
          現在、お知らせはありません。
        </p>
      </div>
      <div
        v-else
        class="m-2 sm:m-6 items-center">
        <ul class="w-full max-w-5xl mx-auto">
          <li
            v-for="(information, i) in informationList"
            :key="i"
            class="shadow overflow-hidden rounded-md mb-2">
            <div
              class="cursor-pointer flex items-center p-2 md:p-6 hover:bg-gray-100 duration-500"
              @click="show(information)">
              <div class="block md:flex items-center flex-1">
                <!-- <div class="text-xs text-white bg-indigo-400 px-4 py-1 rounded-lg text-center inline md:text-sm md:mx-6 md:w-32 md:block">
                  {{informationCategories[information.category_id]}}
                </div> -->
                <span class="text-xs md:text-sm leading-5 text-gray-500 mx-2 md:mx-0">
                  {{ formatCreatedAt(information) }}
                </span>
                <div class="text-sm md:text-base text-CLIENT_PRIMARY_PINK flex-1 w-full my-2 md:my-0 mx-2 md:mx-6">
                  {{ information.subject }}
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="mx-auto max-w-5xl">
        <button
          class="py-2 px-4 rounded-md font-iroha text-CLIENT_PRIMARY_PINK"
          @click="onClickedBack">
          ＜戻る
        </button>
      </div>
    </div>
  </AppClientSimpleLayout>
</template>

<script setup>
import moment from 'moment'
import {
  computed,
} from 'vue'
import { Inertia } from '@inertiajs/inertia'
import { usePage } from '@inertiajs/inertia-vue3'
import AppClientSimpleLayout from '@/Layouts/AppClientSimpleLayout'

const props = defineProps({
  informationList: {
    type: Array,
    default: () => [],
  },
})

const informationCategories = computed(() => usePage().props.value.informationCategories)
const publicPortalUrl = computed(() => usePage().props.value.portal.publicUrl)

const show = (information) => {
  Inertia.get(route('portal.information.show', {
    information: information.id,
  }))
}

const formatCreatedAt = (information) => {
  const date = moment(information.created_at)
  const formatDate = date.format('yyyy.MM.DD')
  return formatDate
}

const onClickedBack = () => {
  window.location.href = publicPortalUrl.value
}
</script>
